import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body mb-1 d-flex align-items-center gap-2" }

import { useI18n } from 'vue-i18n'
  import CalendarIcon from '@/assets/CalendarIcon.vue'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingDate',
  props: {
    bookingOption: {
      type: Object,
      required: true,
      validator: (value: any) => {
        return value && value.startDate && value.endDate && value.prestTypeId === 1
      }
    }
  },
  setup(__props) {

  

  // i18n setup
  const { t, d } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createVNode(CalendarIcon),
    _createTextVNode(" " + _toDisplayString(_unref(d)(__props.bookingOption.startDate)) + " " + _toDisplayString(_unref(t)('reservations.until')) + " " + _toDisplayString(_unref(d)(__props.bookingOption.endDate)), 1)
  ]))
}
}

})